import { render, staticRenderFns } from "./Terminal.vue?vue&type=template&id=46ab64c9&scoped=true"
var script = {}
import style0 from "./Terminal.vue?vue&type=style&index=0&id=46ab64c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ab64c9",
  null
  
)

export default component.exports